import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-list-dropdown",
  "use": "icon-list-dropdown-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-list-dropdown\"><path d=\"M0,10v9c0,2.76,2.24,5,5,5h14c2.76,0,5-2.24,5-5V10H0Zm18,10H6c-.55,0-1-.45-1-1s.45-1,1-1h12c.55,0,1,.45,1,1s-.45,1-1,1Zm0-4H6c-.55,0-1-.45-1-1s.45-1,1-1h12c.55,0,1,.45,1,1s-.45,1-1,1Zm6-8v-3c0-2.76-2.24-5-5-5H5C2.24,0,0,2.24,0,5v3H24ZM14.08,3h4.87c.69,0,1.03,.83,.54,1.31l-2.44,2.23c-.3,.3-.79,.3-1.09,0l-2.44-2.23c-.48-.48-.14-1.31,.54-1.31Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/list-dropdown.svg
// module id = jDJD
// module chunks = 36